import GA from 'react-ga4';

const GA_EVENT_TIMEOUT = 350;

function promisifyGaEvent(eventName: string, params: Record<string, unknown>) {
    return new Promise<void>((resolve) => {
        const { event_callback: callback } = params;
        const timeout = window.setTimeout(() => {
            window.clearTimeout(timeout);
            resolve();
        }, GA_EVENT_TIMEOUT);

        GA.event(eventName, {
            ...params,
            event_callback: () => {
                window.clearTimeout(timeout);
                if (typeof callback === 'function') {
                    callback();
                }
                resolve();
            },
        });
    });
}

export class AnalyticsService {
    sendExternalLoginButtonClick(provider: string) {
        return promisifyGaEvent('button_click_external', {
            area: 'logon',
            category: 'button',
            provider,
        });
    }

    sendInputStartEvent(field: string) {
        return promisifyGaEvent('input_start', {
            area: 'logon',
            category: 'input',
            field,
        });
    }

    sendLoginButtonClick() {
        return promisifyGaEvent('button_click_login', {
            area: 'logon',
            category: 'button',
        });
    }

    sendRegisterButtonClick() {
        return promisifyGaEvent('button_click_register', {
            area: 'logon',
            category: 'button',
        });
    }

    sendEmailInvalidEvent() {
        return promisifyGaEvent('email_validation', {
            area: 'logon',
            category: 'error',
        });
    }

    sendPasswordInvalidEvent() {
        return promisifyGaEvent('password_validation', {
            area: 'logon',
            category: 'error',
        });
    }

    sendLoginErrorEvent() {
        return promisifyGaEvent('login_error', {
            area: 'logon',
            category: 'error',
        });
    }

    sendLoginEvent(method: string) {
        return promisifyGaEvent('login', {
            area: 'logon',
            category: 'info',
            method,
        });
    }

    sendRegisterEvent() {
        return promisifyGaEvent('sign_up', {
            area: 'logon',
            category: 'info',
            referrer: document.referrer,
        });
    }

    sendSsoLoginErrorEvent({ errorType, domain }: { errorType: string; domain: string }) {
        return promisifyGaEvent('sso_login_error', {
            area: 'logon',
            category: 'error',
            error_type: errorType,
            domain,
        });
    }

    sendShowCaptchaEvent(attempts: number) {
        return promisifyGaEvent('viewed_captcha', {
            area: 'logon',
            category: 'info',
            attempts,
            referrer: document.referrer,
        });
    }
}
